import SelectLanguagePage from 'pages/my/settings/language';

export default SelectLanguagePage;
